import { render, staticRenderFns } from "./edit-property-header-block.vue?vue&type=template&id=4409950e&"
import script from "./edit-property-header-block.vue?vue&type=script&lang=js&"
export * from "./edit-property-header-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports